const SpeedComparison = () => {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 sm:gap-12 mb-12 sm:mb-16">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-accent mb-4">
              Elevate your<br />
              Transparency<br />
              Reporting...
            </h2>
          </div>

          <div className="flex-shrink-0">
            <div className="w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 relative">
              <svg viewBox="0 0 100 100" className="w-full h-full">
                <circle cx="50" cy="50" r="45" fill="none" stroke="#3B82F6" strokeWidth="2" />
                <circle cx="50" cy="50" r="40" fill="none" stroke="#3B82F6" strokeWidth="1" opacity="0.3" />

                {/* Clock ticks */}
                {[...Array(12)].map((_, i) => {
                  const angle = (i * 30 - 90) * (Math.PI / 180);
                  const x1 = 50 + 42 * Math.cos(angle);
                  const y1 = 50 + 42 * Math.sin(angle);
                  const x2 = 50 + 38 * Math.cos(angle);
                  const y2 = 50 + 38 * Math.sin(angle);
                  return (
                    <line
                      key={i}
                      x1={x1}
                      y1={y1}
                      x2={x2}
                      y2={y2}
                      stroke="#3B82F6"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  );
                })}

                {/* Hour hand */}
                <line x1="50" y1="50" x2="50" y2="30" stroke="#1E40AF" strokeWidth="3" strokeLinecap="round" />

                {/* Minute hand */}
                <line x1="50" y1="50" x2="50" y2="20" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" />

                {/* Center dot */}
                <circle cx="50" cy="50" r="3" fill="#1E40AF" />

                {/* Top knob */}
                <rect x="47" y="5" width="6" height="4" rx="2" fill="#3B82F6" />
                <line x1="50" y1="9" x2="50" y2="15" stroke="#3B82F6" strokeWidth="2" />
              </svg>
            </div>
          </div>

          <div className="flex-1 text-center md:text-right">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
              <span className="text-accent">From 30 Days<br />to</span><br />
              <span className="text-accent">30 Seconds!</span>
            </h2>
          </div>
        </div>

        <div className="max-w-5xl mx-auto space-y-6">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-accent flex items-center justify-center mt-1">
              <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-base sm:text-lg text-gray-700 flex-1">
              Real-Time Reserves closes the gap between on-chain liabilities and off-chain assets, with on-demand CPA-attestation reporting.
            </p>
          </div>

          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-accent flex items-center justify-center mt-1">
              <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-base sm:text-lg text-gray-700 flex-1">
              Real-Time Proof of Reserves Services reduce your company's operational burdens and saves time.
            </p>
          </div>

          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-accent flex items-center justify-center mt-1">
              <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-base sm:text-lg text-gray-700 flex-1">
              Our services are enabled with proven, market-leading tech that provides key insights for your operations, finance, and custody teams.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeedComparison;
